import React from "react";

import { getIcon } from "../../helpers/icons";
import Link from "../Link";

import style from "./style.module.css";

const Repeater = ({ fields, index, children, onRemove = () => null, deleteBtn = true, id = 'repeater', className = "" }) => {
    return (
        <div key={index} id={id} className={style.repeater}>
            <div className={style.contentCell}>
                {children}
            </div>
            {
                deleteBtn && (
                    <Link className={`${style.deleteButton}${className ? ` ${className}` : ""}`} onClick={() => { onRemove(); fields.remove(index); }}>
                        <i className={getIcon("Delete")} />
                    </Link>
                )
            }
        </div>
    );
};

export default Repeater;